import React from 'react';
import LutromLogo from './LutromLogo';

/**
 * Subtle "Powered by Lutrom Engineering" footer used on customer-facing
 * pages where there is no full dashboard chrome (public QR request, public
 * report view, etc.). Reinforces the brand at exactly the touch-points where
 * a non-employee might first encounter the platform.
 */
const PoweredByLutrom = ({ className = '' }) => (
  <footer
    className={`mt-10 pt-6 pb-4 flex flex-col items-center justify-center gap-2 ${className}`}
    data-testid="powered-by-lutrom"
  >
    <a
      href="https://www.lutrom.co.uk"
      target="_blank"
      rel="noopener noreferrer"
      className="opacity-60 hover:opacity-100 transition-opacity"
      aria-label="Lutrom Engineering"
    >
      <LutromLogo size="sm" />
    </a>
    <div className="text-[10px] uppercase tracking-[0.2em] text-slate-400 text-center">
      Powered by{' '}
      <a
        href="https://www.lutrom.co.uk"
        target="_blank"
        rel="noopener noreferrer"
        className="text-slate-600 hover:text-slate-900 underline-offset-2 hover:underline"
      >
        Lutrom Engineering
      </a>
    </div>
  </footer>
);

export default PoweredByLutrom;
